var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Add-Circle--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Add Circle Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-circle--button-remove-cross-add-buttons-plus-circle-+-mathematics-math"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "M18.57 35.81357142857143c11.035885714285715 0 17.24357142857143 -6.207685714285715 17.24357142857143 -17.24357142857143S29.605885714285716 1.3264285714285715 18.57 1.3264285714285715 1.3264285714285715 7.534114285714286 1.3264285714285715 18.57s6.207685714285715 17.24357142857143 17.24357142857143 17.24357142857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.57 35.81357142857143c11.035885714285715 0 17.24357142857143 -6.207685714285715 17.24357142857143 -17.24357142857143S29.605885714285716 1.3264285714285715 18.57 1.3264285714285715 1.3264285714285715 7.534114285714286 1.3264285714285715 18.57s6.207685714285715 17.24357142857143 17.24357142857143 17.24357142857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1179",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.57 10.611428571428572v15.917142857142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1180",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.528571428571432 18.57 10.611428571428572 18.57",
    strokeWidth: 2.86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleStreamlineFlex);
export default __webpack_public_path__ + "static/media/Add-Circle--Streamline-Flex.80419387be2f961d106e6bd98892cc6c.svg";
export { ForwardRef as ReactComponent };